import './Dashboard.js';
import '../css/Dashboardpage.css';


function Verify_member() {


  const disableRightClick = (e) => {
    e.preventDefault();
  };


  return (
    <>
      <div className="dashboard_fullpage"  onContextMenu={disableRightClick}>


        <div className="register_design" style={{ backgroundColor: "white", width: "100%", padding: "20px" }}>
          <label htmlFor="member" >New Registered member </label>
          <select id="member" style={{ width: "200px ", height: "20px", padding: "2px" }}>
            <option></option>
            <option></option>
            <option></option>
          </select>

          <table style={{ width: "100%" }}>
            <br /><br />
            <tr>
              <th>Photo</th>
              <th>Name (ID)</th>
              <th>Gender</th>
              <th>Joining Date</th>
              <th>Date of Birth</th>
              <th>Age</th>
              <th>Mobile Verified</th>
              <th>Email Verified</th>
              <th>Documentation Verified</th>
            </tr>
            <tr>
              <td><img style={{ width: "50px", height: "50px" }} src="https://market-resized.envatousercontent.com/photodune.net/EVA/TRX/b4/06/80/53/a4/v1_E11/E1139EUA.jpeg?auto=format&q=94&mark=https%3A%2F%2Fassets.market-storefront.envato-static.com%2Fwatermarks%2Fphoto-260724.png&opacity=0.2&cf_fit=contain&w=590&h=884&s=ade8cb2e5494eaec7be4aec07992678588d92aac7b5fa40a4c5398593972fa6a" /></td>
              <td>sangeetha</td>
              <td>Female</td>
              <td>Dec 4,2025</td>
              <td>oct 11,1992</td>
              <td>33</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><img style={{ width: "50px", height: "50px" }} src="https://market-resized.envatousercontent.com/photodune.net/EVA/TRX/b4/06/80/53/a4/v1_E11/E1139EUA.jpeg?auto=format&q=94&mark=https%3A%2F%2Fassets.market-storefront.envato-static.com%2Fwatermarks%2Fphoto-260724.png&opacity=0.2&cf_fit=contain&w=590&h=884&s=ade8cb2e5494eaec7be4aec07992678588d92aac7b5fa40a4c5398593972fa6a" /></td>
              <td>Vasanthi</td>
              <td>Female</td>
              <td>Dec 4,2025</td>
              <td>oct 11,1992</td>
              <td>33</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><img style={{ width: "50px", height: "50px" }} src="https://market-resized.envatousercontent.com/photodune.net/EVA/TRX/b4/06/80/53/a4/v1_E11/E1139EUA.jpeg?auto=format&q=94&mark=https%3A%2F%2Fassets.market-storefront.envato-static.com%2Fwatermarks%2Fphoto-260724.png&opacity=0.2&cf_fit=contain&w=590&h=884&s=ade8cb2e5494eaec7be4aec07992678588d92aac7b5fa40a4c5398593972fa6a" /></td>
              <td>Raghu</td>
              <td>Male</td>
              <td>Dec 4,2025</td>
              <td>oct 11,1992</td>
              <td>33</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><img style={{ width: "50px", height: "50px" }} src="https://market-resized.envatousercontent.com/photodune.net/EVA/TRX/b4/06/80/53/a4/v1_E11/E1139EUA.jpeg?auto=format&q=94&mark=https%3A%2F%2Fassets.market-storefront.envato-static.com%2Fwatermarks%2Fphoto-260724.png&opacity=0.2&cf_fit=contain&w=590&h=884&s=ade8cb2e5494eaec7be4aec07992678588d92aac7b5fa40a4c5398593972fa6a" /></td>
              <td>kiran</td>
              <td>Male</td>
              <td>Dec 4,2025</td>
              <td>oct 11,1992</td>
              <td>33</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><img style={{ width: "50px", height: "50px" }} src="https://market-resized.envatousercontent.com/photodune.net/EVA/TRX/b4/06/80/53/a4/v1_E11/E1139EUA.jpeg?auto=format&q=94&mark=https%3A%2F%2Fassets.market-storefront.envato-static.com%2Fwatermarks%2Fphoto-260724.png&opacity=0.2&cf_fit=contain&w=590&h=884&s=ade8cb2e5494eaec7be4aec07992678588d92aac7b5fa40a4c5398593972fa6a" /></td>
              <td>pavithra</td>
              <td>Female</td>
              <td>Dec 4,2025</td>
              <td>oct 11,1992</td>
              <td>33</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
      </div>
      <footer className='bg-dark text-white text-center p-1 '>
        <label>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
      </footer>
    </>

  );
}
export default Verify_member;